import { viewport } from './viewport';

document.querySelectorAll('.inner-blocks > *, .wp-block-column > *').forEach((el) => {
  if (!el.hasAttribute('data-no-animation')) {
    viewport.observe(el, (el) => el.classList.add('animated'));
  }
});